import { render } from "./TsNavbar.vue?vue&type=template&id=4ac36980"
import script from "./TsNavbar.vue?vue&type=script&lang=js"
export * from "./TsNavbar.vue?vue&type=script&lang=js"

import "./TsNavbar.vue?vue&type=style&index=0&id=4ac36980&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__